import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { checkIsLanguageSupported, checkValidCultureFormat } from '@/libs/utils/language'

type B2BecLinkProps = {
  to?: string
  state?: Record<string, unknown>
  children?: React.ReactNode
} & React.ComponentProps<typeof Link>

const B2BecLink = ({
  to = '',
  state,
  children = null,
  ...props
}: B2BecLinkProps): React.ReactNode => {
  const { i18n } = useTranslation()

  const pathname = useMemo(() => {
    const paths = to?.split('/')?.filter((path) => path !== '')
    const locale = checkValidCultureFormat(i18n.language) ? i18n.language : 'en'

    if (paths && paths.length > 0) {
      const culture = paths[0]
      if (checkValidCultureFormat(culture) && checkIsLanguageSupported(culture)) {
        return to
      }
    }

    return `/${locale}${to.startsWith('/') ? to : `/${to}`}`
  }, [to, i18n.language])

  return (
    <Link state={{ ...state }} to={pathname} {...props}>
      {children}
    </Link>
  )
}

export default B2BecLink
